import { Form as FormikForm } from 'formik';
import styled from 'styled-components/macro';
import { radius, shadow, space } from '../../../theme/tokens';
import * as common from '../../common/elements/Form';
import { StaffNavButton } from '../../staff/elements/User';

export const Form = styled(FormikForm)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 95%;
  /* keep the modal on screen on short phones */
  max-height: calc(100vh - ${space[6]});
  overflow-y: auto;
  background: ${({ theme }) => theme.appBackground};
  border-radius: ${radius.lg};
  box-shadow: ${shadow.lg};
  ${common.ModalScreenWidthMQs}

  & > ${common.FieldGroup} {
    padding: ${space[3]} ${space[4]};
  }
`;

export const SubmitChangesButton = styled(StaffNavButton)``;

export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
